/**
 * @license Copyright (c) Microsoft Corporation. All rights reserved.
 */

// src\core\src\Core\Utils\OriginRegEx.ts in CRM.Client.UnifiedClient

type Environment =
	| "PROD"
	| "EU"
	| "GCCHigh"
	| "GCCModerate"
	| "USDoD"
	| "Mooncake"
	| "Eaglex"
	| "Raptorx"
	| "TIP"
	| "TEST";

const originRegEx: Record<Environment, RegExp> = {
	PROD: /.*\.crm([2-3]|[5-8]|14|15|20|21|25|27)?\.dynamics\.com$/,
	EU: /.*\.crm(4|11|12|16|17|19|22|23|24|26)\.dynamics\.com$/,
	GCCHigh: /.*\.crm\.microsoftdynamics\.us$/,
	GCCModerate: /.*\.crm9\.dynamics\.com$/,
	USDoD: /.*\.crm\.appsplatform\.us$/,
	Mooncake: /.*\.crm\.dynamics\.cn$/,
	Eaglex: /.*\.crm\.dynamics\.eaglex\.ic\.gov$/,
	Raptorx: /.*\.crm\.dynamics\.microsoft\.scloud$/,
	TIP: /.*\.crm(10|ppeau)\.dynamics\.com$/,
	TEST: /(.*\.crmtest\.dynamics\.com$|.*\.crm\.dynamics-int\.com$|.*\.crm[2]?\.crmlivetie\.com$|.*\.contoso\.com:444$|.*\.microsoft\.com$|.*\.msmecrm\.com$|.*\.crm\.crmlivetoday\.com$|.*\.crm\.1boxtest\.com$|.*\.mocaifd\d*\.com:444$|.*\.crm\.crmifd\.com$|.*\.msmecrm\.com:444$|.*localhost.*|http:\/\/(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$)/,
};

function getEnvironmentFromUrl(url: string) {
	for (const key in originRegEx) {
		if (originRegEx.hasOwnProperty(key) && originRegEx[key as Environment].test(url)) {
			return key as Environment;
		}
	}
}

export { Environment, originRegEx, getEnvironmentFromUrl };
